import type { OrderTotal } from '@order/hooks/useOrderTotal'

/**
 * Resolves what the customer pays and what to strike through.
 * `custom` is the sum of the user applied discounts, negative.
 */
const getDiscountedTotals = (orderTotal: OrderTotal, custom: number) => {
  const price = orderTotal.remote || orderTotal.local || 0
  // Either flag means the total is already net, so `custom` must not be applied again
  const isNet = orderTotal.hasFinalPrices || orderTotal.includesDiscounts

  return {
    discounted: isNet ? orderTotal.resolved : Math.max(0, price + custom),
    base: isNet ? orderTotal.resolved - custom : orderTotal.resolved,
    isNet,
  }
}

export default getDiscountedTotals
